import { OnboardingStepCommon, Blue, Content } from './OnboardingStepCommon';
import Icon from './Icon';

const OnboardingStepOne = () => {
  return (
    <OnboardingStepCommon>
      <Content>
        <Icon name='lizzy-logo-colored' />
        <h2>
          Welcome to Lizzy Playground
        </h2>

        <p>
          <Blue>Please note:</Blue>
        </p>
        <p>
          &nbsp;
        </p>
        <p>
          This is a POC test environment - not a product
        </p>
        <p style={{marginTop: '15px'}}>
          <small>
            This playground is an early, unstable, non-commercial, test environment. 
            The final product will be a desktop application that will integrate with Microsoft Word.
          </small>
        </p>
      </Content>
    </OnboardingStepCommon>
  );
}

export default OnboardingStepOne;